import { render } from "./recoveryPassword.vue?vue&type=template&id=f852711a&scoped=true"
import script from "./recoveryPassword.vue?vue&type=script&lang=js"
export * from "./recoveryPassword.vue?vue&type=script&lang=js"

import "./recoveryPassword.vue?vue&type=style&index=0&id=f852711a&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f852711a"]])

export default __exports__